module.exports = __webpack_public_path__ + "img/9788936471897.246ae108.jpg";